/* Spanish catalog mirroring locale-settings-integrations-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'set.integr.wooImported': '{orders} eventos de venta y reembolso importados',
  'set.integr.wooLastSync': 'Última sincronización: {date}',
  'set.integr.wooDisconnectTitle': 'Desconectar WooCommerce',
  'set.integr.wooDisconnectHelp': 'Plumme dejará de recuperar pedidos nuevos. Los borradores y clientes ya importados conservan sus referencias de origen.',
  'set.integr.wooDisconnectedToast': 'WooCommerce se ha desconectado.',
  'set.integr.wooDisconnectError': 'No se pudo desconectar WooCommerce.',
  'set.integr.wooUnavailable': 'La integración con WooCommerce no está disponible en esta versión.'
});
